module.exports = __webpack_public_path__ + "img/PL08783.ddc593c4.png";